<template>
  <div class="media-intern">
    <div class="media-intern__title">Create your autonomous social media intern</div>
    <div class="media-intern__description">Generate a digital copy of yourself on X and other social platforms in minutes. Use it to co-pilot your posts and replies, boosting impressions and engagement exponentially. Take full control with no black box, as your agent runs in a secure, trusted execution environment with advanced key management.</div>
    <div class="media-intern__controls">
      <Button title="Get early access" @click="$router.push('/copilot')" />
      <div class="media-intern__eliza">
        powered by
        <div class="eliza-icon" />
      </div>
    </div>
  </div>
</template>
<script>
import Button from '../Button';
export default {
  components: {
    Button,
  },
  setup() {
    
  },
}
</script>
<style lang="scss" scoped>
  .media-intern {
    font-family: 'YoungSerif-Regular';
    border-radius: $cardRadius;
    background-color: $panelBgColor;
    padding: clamp(25px, 3.5vw, 40px);
    display: flex;
    flex-direction: column;
    width: 50%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    }

    &__title {
      font-size: clamp(24px, 3.8vw, 42px);
      color: $textBlack;
      text-align: left;
      line-height: clamp(30px, 1.15em, 48px);
      font-weight: bold;
      background: linear-gradient(90deg, $textBlack 80%, #444444);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      letter-spacing: -0.5px;
    }

    &__description {
      margin-top: clamp(15px, 2vw, 24px);
      font-size: clamp(15px, 1.2vw, 18px);
      line-height: clamp(24px, 1.5em, 28px);
      text-align: left;
      font-weight: 500;
      color: #555;
    }

    &__controls {
      margin-top: clamp(15px, 2.5vw, 30px);
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
    }

    &__eliza {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 16px;
      font-weight: 500;
      color: #777;
      margin-top: 10px;
      max-width: 100%;

      .eliza-icon {
        width: 145px;
        height: 25px;
        background-repeat: no-repeat;
        background-image: url("~@/assets/icons/elizaos.svg");
        background-size: contain;
        margin-left: 15px;
        flex-shrink: 1;
      }
    }

    /* Add intermediate breakpoint for better scaling */
    @media (min-width: 769px) and (max-width: 1024px) {
      padding: 35px;
      width: 50%;
      
      &__title {
        font-size: 34px;
        line-height: 40px;
      }
      
      &__description {
        font-size: 16px;
        line-height: 26px;
        margin-top: 20px;
      }
      
      &__controls {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        margin-top: 25px;
      }
      
      &__eliza {
        margin-top: 8px;
        font-size: 15px;
        
        .eliza-icon {
          width: 120px;
          height: 20px;
          margin-left: 12px;
        }
      }
      
      /* Additional improvements */
      transform-origin: center top;
    }

    @media (max-width: $tabletSize) {
      width: 100%;
      padding: 25px;
      border-radius: $cardRadiusMini;
      box-sizing: border-box;

      &__title {
        font-size: 24px;
        line-height: 30px;
      }

      &__description {
        font-size: 15px;
        line-height: 24px;
        margin-top: 15px;
      }

      &__controls {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        margin-top: 15px;
      }

      &__eliza {
        margin-top: 5px;
        font-size: 14px;
        flex-wrap: wrap;

        .eliza-icon {
          width: 97px;
          height: 16px;
          background-size: contain;
          margin-left: 10px;
        }
      }
    }

    @media (max-width: 400px) {
      &__eliza {
        flex-direction: column;
        align-items: flex-start;
        
        .eliza-icon {
          margin-left: 0;
          margin-top: 5px;
        }
      }
    }
  }
</style>
